import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  signal,
} from '@angular/core';
import { ButtonComponent } from '@fundamental-ngx/core/button';
import { ContentDensityDirective } from '@fundamental-ngx/core/content-density';
import {
  DynamicPageComponent,
  DynamicPageContentComponent,
  DynamicPageHeaderComponent,
} from '@fundamental-ngx/core/dynamic-page';
import {
  IllustratedMessageActionsComponent,
  IllustratedMessageComponent,
  IllustratedMessageFigcaptionComponent,
  IllustratedMessageTextDirective,
  IllustratedMessageTitleDirective,
} from '@fundamental-ngx/core/illustrated-message';
import { sendCustomMessage } from '@luigi-project/client';
import { I18nService, LuigiCoreService } from '@openmfp/portal-ui-lib';

@Component({
  selector: 'app-no-vpn-handling',
  imports: [
    DynamicPageComponent,
    DynamicPageHeaderComponent,
    DynamicPageContentComponent,
    IllustratedMessageComponent,
    IllustratedMessageActionsComponent,
    IllustratedMessageFigcaptionComponent,
    IllustratedMessageTitleDirective,
    IllustratedMessageTextDirective,
    ButtonComponent,
    ContentDensityDirective,
  ],
  templateUrl: './no-vpn-handling.component.html',
  styleUrl: './no-vpn-handling.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class NoVPNHandlingComponent implements AfterContentInit {
  readonly config = signal<any>({
    scene: {
      url: 'assets/moments/tnt-Scene-UnsuccessfulAuth.svg',
      id: 'tnt-Scene-UnsuccessfulAuth',
    },
    dialog: {
      url: 'assets/moments/tnt-Dialog-UnsuccessfulAuth.svg',
      id: 'tnt-Dialog-UnsuccessfulAuth',
    },
    spot: {
      url: 'assets/moments/tnt-Spot-UnsuccessfulAuth.svg',
      id: 'tnt-Spot-UnsuccessfulAuth',
    },
    illustratedMessageTitle: '',
    illustratedMessageText: '',
    buttons: [],
  });

  constructor(
    private luigiCoreService: LuigiCoreService,
    private i18nService: I18nService,
  ) {}

  async ngAfterContentInit() {
    this.luigiCoreService.ux().hideAppLoadingIndicator();
    this.i18nService.afterInit();
    await this.setConfig();
  }

  retry(): void {
    sendCustomMessage({
      id: 'general.reload-frame',
    });
  }

  private async setConfig(): Promise<void> {
    this.config.set({
      ...this.config(),
      illustratedMessageTitle: await this.i18nService.getTranslationAsync(
        'VPN_NEEDED_PAGE_TITLE',
      ),
      illustratedMessageText: await this.i18nService.getTranslationAsync(
        'VPN_NEEDED_PAGE_DESCRIPTION',
      ),
    });
  }
}
